import React from "react";
import {Link} from "react-router-dom";

export const url = process.env.REACT_APP_API_URL;

//const CardItem = (props) => { props.item.name}
// ... {
const ItemCard = ({item}) => {
    return (
        <div className='p-2'>
            <div className='grid grid-cols-3 shadow-lg bg-white rounded-lg h-32 xl:h-44'>
                <div className='col-span-1'>
                    <img
                        alt={item.name}
                        className='rounded-lg rounded-r-none h-32 xl:h-44 object-cover  min-w-full'
                        src={item.picture}
                    />
                </div>

                <div
                    className='col-span-2 p-1 shadow-lg shadow-none bg-white bg-transparent rounded-lg rounded-l-none '>
                    <h2 className=' tracking-tight text-base font-semibold uppercase text-secondary '>
                        {item.name}
                    </h2>
                    <p className='text-gray-700 text-xs md:text-sm leading-snug mt-1 xl:mt-8'>{item.ingredients}</p>
                    <div className='grid grid-cols-2 gap-2 mt-4 '>
            <span className=' col-span-2 text-sm font-semibold text-gray-800 block '>
              Menu {item.priceinMenu}€  { item.pricealacarte? `| Seul ${item.pricealacarte}€` :  ''    }
            </span>
                        {/*<Link*/}
                        {/*  className='col-span-1 text-sm font-semibold text-gray-800'*/}
                        {/*  to={`/post/${item.id}`}>*/}
                        {/*  Voir plus*/}
                        {/*</Link>*/}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ItemCard;
